import { DynamoDBClient, PutItemCommand, QueryCommand } from '@aws-sdk/client-dynamodb';
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb';

const client = new DynamoDBClient();

export const putItem = async (tableName: string, item: object) => {
    const command = new PutItemCommand({ TableName: tableName, Item: marshall(item) });

    return await client.send(command);
};

export const getLatestItem = async (tableName: string) => {
    const command = new QueryCommand({
        TableName: tableName,
        KeyConditionExpression: '#rate = :rate',
        ExpressionAttributeNames: {
            '#rate': 'rate',
        },
        ExpressionAttributeValues: {
            ':rate': { S: 'rate' },
        },
        ScanIndexForward: false,
        Limit: 1,
    });

    const result = await client.send(command);
    return result.Items && result.Items.length > 0 ? unmarshall(result.Items[0]) : null;
};
